import { useSelector } from 'react-redux';
import { authSelector } from '../features/auth/slice';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = () => {
  const { me, loading } = useSelector(authSelector.selectAuthState);

  if (loading) return null;

  if (!me?.loginId) {
    return <Navigate to="/login" replace />;
  }

  if (me.adminYn !== 'Y') {
    return <Navigate to="/no-access" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
